import {
  faArrowLeft,
  faArrowRight,
  faFilter,
  faFilterCircleXmark,
  faPlus,
  faRefresh,
  faSearch,
  faTable,
  faTachometer,
  faTicket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Scroll from "react-scroll";
import { useRecoilState } from "recoil";
import { deletePromoCodeAPI, getPromoCodeListAPI } from "../../API/PromoCode";
import {
  topAlertMessageState,
  topAlertStatusState,
  usersCreatedState,
  usersSearchTextState,
  usersShowFilterState,
  usersTrialStatusState,
} from "../../AppState";
import { DEFAULT_USER_LIST_SORT_BY_VALUE } from "../../Constants/App";

import FormErrorBox from "../../Components/Reusable/FormErrorBox";
import FormInputFieldWithButton from "../../Components/Reusable/FormInputFieldWithButton";
import PageLoadingContent from "../../Components/Reusable/PageLoadingContent";
import useLocalStorage from "../../Hooks/useLocalStorage";
import PromoCodeList from "./list";
import OrgPromoCodeMobileList from "./list-mobile";

function OrgPromoCode() {
  const [topAlertMessage, setTopAlertMessage] =
    useRecoilState(topAlertMessageState);
  const [topAlertStatus, setTopAlertStatus] =
    useRecoilState(topAlertStatusState);
  const [showFilter, setShowFilter] = useRecoilState(usersShowFilterState);
  const [temporarySearchText, setTemporarySearchText] =
    useRecoilState(usersSearchTextState); // The search field value as your writes their query.
  const [trialStatus, setTrialStatus] = useRecoilState(usersTrialStatusState); // Filtering
  const [created, setCreated] = useRecoilState(usersCreatedState); // Filtering

  ////
  //// Component states.
  ////
  const [profile] = useLocalStorage("RHEA_CMS_USER_PROFILE");
  const [errors, setErrors] = useState({});
  const [isFetching, setFetching] = useState(false);
  const [actualSearchText, setActualSearchText] = useState(temporarySearchText); // The actual search query value to submit to the API.
  const [sortByValue, setSortByValue] = useState(
    DEFAULT_USER_LIST_SORT_BY_VALUE
  ); // Sorting
  const [listData, setListData] = useState(""); // List Data + Pagination
  const [pageSize, setPageSize] = useState(25); // Pagination
  const [previousCursors, setPreviousCursors] = useState([]); // Pagination
  const [nextCursor, setNextCursor] = useState(""); // Pagination
  const [currentCursor, setCurrentCursor] = useState(""); // Pagination

  function onPromoCodeListSuccess(response) {
    setListData(response);
    if (response.hasNextPage) {
      setNextCursor(response.nextCursor);
    }
  }

  function onPromoCodeListError(apiErr) {
    setErrors(apiErr);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onPromoCodeListDone() {
    setFetching(false);
  }

  function onPromoCodeDeleteSuccess(response) {
    setTopAlertStatus("success");
    setTopAlertMessage("PromoCode deleted");
    setTimeout(() => {
      setTopAlertMessage("");
    }, 2000);

    defaultFetchList();
  }

  function onPromoCodeDeleteError(apiErr) {
    setErrors(apiErr);

    setTopAlertStatus("danger");
    setTopAlertMessage("Failed deleting");
    setTimeout(() => {
      setTopAlertMessage("");
    }, 2000);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onPromoCodeDeleteDone() {
    setFetching(false);
  }

  const onClearFilterClick = (e) => {
    setShowFilter(false);
    setActualSearchText("");
    setTemporarySearchText("");
    setTrialStatus(null);
    setCreated(368);
  };

  const onSearchButtonClick = (e) => {
    setActualSearchText(temporarySearchText);
  };

  const defaultFetchList = () => {
    fetchList(
      actualSearchText,
      trialStatus,
      currentCursor,
      pageSize,
      created,
      sortByValue
    );
  };

  const fetchList = (keywords, ts, cur, limit, cdr, sbv) => {
    setFetching(true);
    setErrors({});

    let params = new Map();
    if (keywords !== undefined && keywords !== null && keywords !== "") {
      params.set("search", keywords);
    }
    if (ts !== undefined && ts !== null && ts !== "") {
      params.set("trial_status", ts);
    }

    params.set("page_size", limit); // Pagination

    if (cur !== "") {
      params.set("cursor", cur); // Pagination
    }

    // DEVELOPERS NOTE: Our `sortByValue` is string with the sort field
    // and sort order combined with a comma seperation. Therefore we
    // need to split as follows.
    if (sbv !== undefined && sbv !== null && sbv !== "") {
      const sortArray = sbv.split(",");
      params.set("sort_field", sortArray[0]); // Sort (1 of 2)
      params.set("sort_order", sortArray[1]); // Sort (2 of 2)
    }
    if (cdr !== undefined && cdr !== null && cdr !== "") {
      let end = Math.floor(Date.now() / 1000); // Current unix time.

      let start = end - cdr * 24 * 60 * 60; // Subtracting cdr days in seconds.

      // console.log("days:", cdr, "start:", start, "end:", end);

      // const [cs, ce] = cdr;
      params.set("start", start); // Sort (1 of 2)
      params.set("created_lte", end); // Sort (2 of 2)
    }
    params.set("organizationId", profile.organizationId);
    // Fetch data.
    getPromoCodeListAPI(
      params,
      onPromoCodeListSuccess,
      onPromoCodeListError,
      onPromoCodeListDone
    );
  };

  const onNextClicked = (e) => {
    // console.log("onNextClicked");
    let arr = [...previousCursors];
    arr.push(currentCursor);
    setPreviousCursors(arr);
    setCurrentCursor(nextCursor);
  };

  const onPreviousClicked = (e) => {
    // console.log("onPreviousClicked");
    let arr = [...previousCursors];
    const previousCursor = arr.pop();
    setPreviousCursors(arr);
    setCurrentCursor(previousCursor);
  };

  const deletePromoCode = (id) => {
    deletePromoCodeAPI(
      id,
      onPromoCodeDeleteSuccess,
      onPromoCodeDeleteError,
      onPromoCodeDeleteDone
    );
  };
  ////
  //// Misc.
  ////

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);
      fetchList(
        actualSearchText,
        trialStatus,
        currentCursor,
        pageSize,
        created,
        sortByValue
      );
    }

    return () => {
      mounted = false;
    };
  }, [
    actualSearchText,
    trialStatus,
    currentCursor,
    pageSize,
    created,
    sortByValue,
  ]);

  ////
  //// Component rendering.
  ////

  // console.log("created:", created);

  return (
    <>
      <div className="container">
        <section className="section">
          {/* Desktop Breadcrumbs */}
          <nav className="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/org-dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li className="is-active">
                <Link to="/org-promo-code" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faTicket} />
                  &nbsp;Promo Code
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav
            className="breadcrumb is-hidden-desktop"
            aria-label="breadcrumbs"
          >
            <ul>
              <li className="">
                <Link to={`/org-dashboard`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Dashboard
                </Link>
              </li>
            </ul>
          </nav>

          {/* Model(s) */}
          {/* None in this page */}

          {/* Content */}
          <nav className="box">
            <div className="columns">
              <div className="column">
                <h1 className="title is-4">
                  <FontAwesomeIcon className="fas" icon={faTicket} />
                  &nbsp;Promo Code
                </h1>
              </div>
              {!isFetching && (
                <div className="column has-text-right">
                  <button
                    className="button is-small is-info is-fullwidth-mobile"
                    onClick={defaultFetchList}
                  >
                    <FontAwesomeIcon className="mdi" icon={faRefresh} />
                    <span className="is-hidden-desktop is-hidden-tablet">
                      &nbsp;Refresh
                    </span>
                  </button>
                  &nbsp;
                  <button
                    onClick={(e, i) => {
                      setShowFilter(!showFilter);
                    }}
                    className="button is-small is-link is-fullwidth-mobile"
                    type="button"
                  >
                    <FontAwesomeIcon className="mdi" icon={faFilter} />
                    &nbsp;Filter
                  </button>
                  &nbsp;
                  <Link
                    to={`/org-promo-code/add`}
                    className="button is-small is-success is-fullwidth-mobile"
                    type="button"
                  >
                    <FontAwesomeIcon className="mdi" icon={faPlus} />
                    &nbsp;New
                  </Link>
                </div>
              )}
            </div>

            {/* Filter Box */}
            {showFilter && (
              <>
                <div
                  className="has-background-white-bis"
                  style={{ borderRadius: "15px", padding: "20px" }}
                >
                  {/* Filter Title + Clear Button */}
                  <div className="columns">
                    <div className="column is-half">
                      <strong>
                        <u>
                          <FontAwesomeIcon className="mdi" icon={faFilter} />
                          &nbsp;Filter
                        </u>
                      </strong>
                    </div>
                    <div className="column is-half has-text-right">
                      <Link onClick={onClearFilterClick}>
                        <FontAwesomeIcon
                          className="mdi"
                          icon={faFilterCircleXmark}
                        />
                        &nbsp;Clear Filter
                      </Link>
                    </div>
                  </div>

                  {/* Filter Options */}
                  <div className="columns">
                    <div className="column is-half">
                      <FormInputFieldWithButton
                        label={"Search"}
                        name="temporarySearchText"
                        type="text"
                        placeholder="Search"
                        helpText=""
                        onChange={(e) => setTemporarySearchText(e.target.value)}
                        isRequired={true}
                        maxWidth="100%"
                        buttonLabel={
                          <>
                            <FontAwesomeIcon className="fas" icon={faSearch} />
                          </>
                        }
                        onButtonClick={onSearchButtonClick}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {isFetching ? (
              <>
                <PageLoadingContent displayMessage={"Please wait"} />
              </>
            ) : (
              <>
                <FormErrorBox errors={errors} />
                {listData &&
                (listData.length > 0 || previousCursors.length > 0) ? (
                  <div className="container">
                    {/* ##################################################################
                                            EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP SCREEN.
                                            ################################################################## */}

                    <div className="is-hidden-touch">
                      <PromoCodeList
                        listData={listData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        previousCursors={previousCursors}
                        onPreviousClicked={onPreviousClicked}
                        onNextClicked={onNextClicked}
                        onDeletePromoCode={deletePromoCode}
                      />
                    </div>

                    {/* ###########################################################################
                                            EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR MOBILE SCREEN.
                                            ###########################################################################   */}

                    <div className="is-fullwidth is-hidden-desktop">
                      <OrgPromoCodeMobileList
                        listData={listData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        previousCursors={previousCursors}
                        onPreviousClicked={onPreviousClicked}
                        onNextClicked={onNextClicked}
                        onDeletePromoCode={deletePromoCode}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="hero-body">
                    <p className="title">
                      <FontAwesomeIcon className="fas" icon={faTable} />
                      &nbsp;No data
                    </p>
                    <p className="subtitle">
                      No data.
                      <b>
                        <Link to="/users/add">
                          Click here&nbsp;
                          <FontAwesomeIcon
                            className="mdi"
                            icon={faArrowRight}
                          />
                        </Link>
                      </b>
                      to get started creating your first user.
                    </p>
                  </div>
                )}
              </>
            )}
          </nav>
        </section>
      </div>
    </>
  );
}

export default OrgPromoCode;
